import development from "@/config/development";
import production from "@/config/production";

export default {
  install(Vue) {
    if (process.env.NODE_ENV === "production") {
      Vue.prototype.$config = Object.freeze(production);
    } else {
      Vue.prototype.$config = Object.freeze(development);
    }
  }
};
